<template>
  <v-dialog
    v-model="show"
    max-width="800"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('common.edit') }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          {{ $t('common.edit') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="location.title"
            :label="$t('common.title')"
            outlined
            dense
          />
          <v-autocomplete
            v-model="location.countryId"
            :items="countries"
            :label="$t('common.country')"
            :loading="loading"
            item-text="name"
            item-value="id"
            auto-select-first
            outlined
            dense
          />
          <v-autocomplete
            v-model="location.locationAreaId"
            :items="[]"
            :loading="loading"
            :label="$t('common.area')"
            auto-select-first
            return-object
            outlined
            dense
          />
          <v-text-field
            v-model="location.address"
            :label="$t('common.address')"
            outlined
            dense
          />
          <v-select
            v-model="location.locationTypeId"
            :items="types"
            :loading="loading"
            :label="$tc('common.type')"
            item-text="title"
            item-value="id"
            outlined
            dense
          />
          <v-textarea
            v-if="$store.getters.isInternal"
            v-model="location.notes"
            :label="$t('locationDetail.notes')"
            clearable
            outlined
            dense
          />
          <v-divider class="mb-5" />
          <h4 class="mb-2">
            {{ $t('locationDetail.contactDetails') }}
          </h4>
          <v-text-field
            v-model="location.contactName"
            :label="$t('common.name')"
            clearable
            outlined
            dense
          />
          <v-text-field
            v-model="location.contactEmail"
            :label="$t('common.email')"
            clearable
            outlined
            dense
          />
          <v-text-field
            v-model="location.contactPhone"
            :label="$t('common.phone')"
            clearable
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="saving" @click="save">
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LocationEditDialog',
  props: {
    initialLocation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: false,
      loading: true,
      saving: false,
      location: JSON.parse(JSON.stringify(this.initialLocation)),
      types: [],
      countries: [],
      areas: []
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.getMetadata();
      }
    }
  },
  methods: {
    save: async function() {
      this.saving = true;
      
      try {
        const {
          title,
          initials,
          address,
          contactName,
          contactEmail,
          contactPhone,
          countryId,
          locationTypeId,
          locationAreaId,
          notes,
          externalReferences
        } = this.location;

        const { data } = await this.$api.patch(`locations/${this.initialLocation.id}`, {
          title,
          initials,
          address,
          contactName,
          contactEmail,
          contactPhone,
          countryId,
          locationTypeId,
          locationAreaId,
          notes,
          externalReferences
        });

        if (!data.success) {
          console.error(data);

          if (data.errors?.length) {
            throw data.errors[0].message;
          }

          else {
            throw 'An unknown error occurred';
          }
        }

        this.$notifier.showSuccess({});
        this.$emit('save:success')
        this.close();
      } catch (error) {
        this.$notifier.showError({});
        console.error(error);
      } finally {
        this.saving = false;
      }
    },
    getMetadata: async function() {
      this.loading = true;

      try {
        const [ countries, types ] = await Promise.all([
          this.$api.get('countries'),
          this.$api.get('location-types')
        ]);

        this.countries = countries.data;
        this.types = types.data;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    },
    close: function() {
      this.show = false;
    }
    // getCountries: async function() {
    //   const { data } = await this.$AuthService.api.get('countries');
    //   this.countries = data;
    // }
  }
}
</script>